import { Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-reasons-to-choose-financing',
  standalone: true,
  imports: [TranslocoDirective],
  templateUrl: './reasons-to-choose-financing.component.html',
  styleUrl: './reasons-to-choose-financing.component.css',
})
export class ReasonsToChooseFinancingComponent {
  cardItems = [
    {
      title: 'card01.title',
      text: 'card01.text',
      imgPath: './assets/financing/process-speed.png',
    },
    {
      title: 'card02.title',
      text: 'card02.text',
      imgPath: './assets/financing/business-search.png',
    },
    {
      title: 'card03.title',
      text: 'card03.text',
      imgPath: './assets/financing/needs_personalization.png',
    },
    {
      title: 'card04.title',
      text: 'card04.text',
      imgPath: './assets/financing/financing_terms.png',
    },
  ];
}
